var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeLazer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.769,
    height: 50,
    viewBox: "0 0 113.769 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4570 4789)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4568.5 -4758.761)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 9.487,
    transform: "translate(9.487) rotate(90)",
    fill: "none",
    stroke: "#c4000b",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4485.49 -4779.315)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 9.487,
    transform: "translate(9.487) rotate(90)",
    fill: "none",
    stroke: "#c4000b",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4467.702 -4755.994)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 9.487,
    transform: "translate(9.487) rotate(90)",
    fill: "none",
    stroke: "#c4000b",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4550.712 -4751.25)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 9.487,
    transform: "translate(9.487) rotate(90)",
    fill: "none",
    stroke: "#c4000b",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4473.044 -4766.897)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 4.007,
    transform: "translate(0) rotate(-90)",
    fill: "none",
    stroke: "#c4000b",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.6 0) rotate(135)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 4.007,
    transform: "translate(4.007 0) rotate(90)",
    fill: "none",
    stroke: "#c4000b",
    strokeLinecap: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4463.953 -4774.012)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 4.007,
    transform: "translate(0) rotate(-90)",
    fill: "none",
    stroke: "#c4000b",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.6 0) rotate(135)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 4.007,
    transform: "translate(4.007 0) rotate(90)",
    fill: "none",
    stroke: "#c4000b",
    strokeLinecap: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4563.785 -4761.132)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 9.487,
    transform: "translate(9.487) rotate(90)",
    fill: "none",
    stroke: "#c4000b",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4558.815 -4789)",
    fill: "none",
    stroke: "#c4000b",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.696,
    cy: 8.696,
    r: 8.696,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.696,
    cy: 8.696,
    r: 7.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4536.003 -4788.838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.26,336.924a1.348,1.348,0,0,0,1.854-.4l.028-.058.017-.01c6.191-5.5,14.834-2.573,14.92-2.542l.055.014a1.306,1.306,0,0,0,1.7-.382c.027-.038,3.054-4.017,9.947-2.215a1.257,1.257,0,0,0,.389.038,1.326,1.326,0,0,0,.877-.017,1.346,1.346,0,0,0,.791-1.73c-3.288-8.815-13.527-13.792-24.351-11.828l-.058.014h-.007l-.409.082a1.427,1.427,0,0,0-.3.062c-10.418,2.212-17.882,10.294-17.857,19.477a1.348,1.348,0,0,0,1.345,1.341h0a1.329,1.329,0,0,0,.991-.447C556.906,334.3,561.064,336.8,561.26,336.924Zm1.754-3.752c-.326-8.145,3.24-11.467,4.691-12.478,1.72.437,6.232,2.3,8.788,10.057C573.388,330.18,567.892,329.87,563.014,333.172Zm25.183-4.887a11.932,11.932,0,0,0-8.98,2.163c-1.706-5.517-4.351-8.619-6.728-10.356C579.18,320.226,585.216,323.335,588.2,328.285Zm-25.29-6.3c-1.551,2.442-2.855,6.177-2.555,11.711a11.975,11.975,0,0,0-8.554,1.125C552.837,329.382,557.074,324.539,562.908,321.984Z",
    transform: "translate(-548.851 -312.593)",
    fill: "#c4000b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.98,319.408l2.648-.478-.337-1.847a1.344,1.344,0,1,0-2.645.481Z",
    transform: "translate(-537.206 -315.977)",
    fill: "#c4000b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.542,329.09H555.8l.671,3.6a1.343,1.343,0,0,0,1.321,1.1,1.5,1.5,0,0,0,.248-.021,1.348,1.348,0,0,0,1.077-1.572Z",
    transform: "translate(-531.89 -283.991)",
    fill: "#c4000b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.634,323.143l2.714,14.587h2.734l-2.8-15.075A11.9,11.9,0,0,0,554.634,323.143Z",
    transform: "translate(-534.744 -299.689)",
    fill: "#c4000b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.632,324.9a1.346,1.346,0,1,0-2.421-1.176l-4.358,8.994h-15.36a1.345,1.345,0,0,0,0,2.69h3.443l-2.249,3.759H552.139a1.345,1.345,0,1,0,0,2.69h5.087l-2.927,4.884a1.345,1.345,0,0,0,.464,1.847,1.326,1.326,0,0,0,.688.193,1.346,1.346,0,0,0,1.156-.653l3.756-6.27h26.583l3.756,6.27a1.346,1.346,0,0,0,2.308-1.386l-3.312-5.524a1.052,1.052,0,0,0,.083-.117ZM582.072,335.4h7.474l-1.754,3.625a1.414,1.414,0,0,1-.217.134h-7.752Z",
    transform: "translate(-544.111 -298.938)",
    fill: "#c4000b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeLazer);
export default __webpack_public_path__ + "static/media/icone-lazer.6638a298f1d3800feeb1e0cbc9a64b2a.svg";
export { ForwardRef as ReactComponent };